import React from 'react';
import {withSentryErrorBoundary} from '@wix/native-components-infra/dist/es/src/HOC/sentryErrorBoundary/sentryErrorBoundary';
import {bootstrapApp} from '../../../commons/bootstrap';
import {CurrencyConverterApp} from './CurrencyConverterApp';

export const component = withSentryErrorBoundary(bootstrapApp(CurrencyConverterApp as React.ComponentType), {
  dsn: 'https://fa06c7c4a6fb4ab28d46fd0c3f4c29c3@sentry-next.wixpress.com/11619',
  config: {environment: 'Native Component'},
});
